<template>
  <!-- 云稼企业 -->
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="banner"/>
      </el-carousel-item>
    </el-carousel>
    <div class="introduce_bg">
      <div class="introduce_top">
        <div class="introduce_top_title">产品介绍</div>
        <div class="introduce_top_content">
          平台赋能企业，从日常经营、客户关系管理及内部办公效率这三点出发，为企业提供生产管理、营销管理、客户管理、财务管理、办公协同、物流管理等功能齐全的服务系统。同时，还能为多种行业提供不同的企业服务方案，完美的实现企业日常经营工作的数字化
        </div>
      </div>
      <div class="introduce_bottom">
        <img
          class="introduce_bottom_left_img"
          src="../../../static/other/ic_introduce_bottom_left.png"
        />
        <div class="introduce_bottom_right">
          <div class="introduce_bottom_right_title">OA协同</div>
          <div class="introduce_bottom_right_content">
            统一办公入口，通过统一"人事、行政、财务、法务等服务资源"，用一套系统支撑全公司日常"沟通、报销、费控、法务、用车、请假、招聘、报修等"工作需求推动公司运营降本增效、满足各部门管控及分子公司独立运维需求
          </div>
          <img
            class="introduce_bottom_right_img"
            src="../../../static/other/ic_introduce_bottom_right_img.png"
          />
        </div>
      </div>
    </div>
    <div class="advantage_bg">
      <div class="advantage_title">产品优势</div>
      <div class="flow_bg">
        <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
          <el-col
            :span="6"
            v-for="(item, index) in advantage_item"
            :key="index"
          >
            <div class="advantage_border">
              <img
                class="line"
                src="../../../static/other/ic_advantage_left_line.png"
              />
              <div class="advantage_right">
                <div class="advantage_right_title">{{ item.title }}</div>
                <div class="advantage_right_content">{{ item.content }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="serve_bg">
      <div class="serve_title">ERP企业服务功能</div>
      <div class="serve_content">八大管理功能 提供定制化服务</div>
      <div class="serve_bottom">
        <div class="serve_bottom_left">
          <img
            class="serve_bottom_left_img"
            src="../../../static/other/ic_serve_bottom_left_img.png"
          />
        </div>
        <div class="serve_bottom_right">
          <img
            class="serve_bottom_right_img"
            src="../../../static/other/ic_serve_bottom_right_img.png"
          />
        </div>
      </div>
    </div>

    <!-- CRM服务模块 -->
    <div class="module_parent">
      <div class="module_title">CRM服务模块</div>
      <div class="module_info">
        帮助企业建立、发展和维护客户关系，通过多维度收集客户数据进行分析，得出客户画像。使得企业能够更好的服务于客户，助力企业利润提升
      </div>
      <div class="module_card">
        <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
          <el-col :span="12" v-for="(item, index) in module_item" :key="index">
            <div class="module_border">
              <div class="module_left">
                <img class="module_img" :src="item.img" />
              </div>
              <div class="module_right">
                <div class="title">{{ item.title }}</div>
                <div class="content">{{ item.content }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      sliders: [
        {
          // img: require("../../../static/slider/a1.png"),
          img: require("../../../static/slider/banner.png"),

        },
      ],
      advantage_item: [
        {
          title: "智能化办公",
          content:
            "结合智能语音、RPA机器人、文本比对、合规检测等多种智能工具，简化办公程序",
        },
        {
          title: "应用定制服务",
          content:
            "基于低代码平台，不懂代码也能按需定制管理应用，满足各类组织多样化管理需求",
        },
        {
          title: "内外协同办公",
          content:
            "连接企业微信、与微信互通，让组织的内部流程、表单、信息直接触达外部客户、供应商、经销商等，实现跨组织协作",
        },
        {
          title: "数字可信技术",
          content:
            "集'数字身份-电子签章-印控中心-电子档案管理'于一体，帮助组织建立可信、有效、安全、可验可查的数字化基础",
        },
        {
          title: "灵活权限体系",
          content:
            "结合组织实际岗位权限，对各个业务模块的发起、审批、查看等权限做细致化配置，确保系统操作、数据安全合规",
        },
        {
          title: "开放集成能力",
          content:
            "可以和市场上现有的各类异构软件无缝集成，帮助组织统一办公入口，多系统单点登录使用，应用、数据、人员全面统一",
        },
        {
          title: "全产业链适配产品",
          content: "实现信创全产业链适配，助力政府、国企、金融机构的信创建设",
        },
        {
          title: "应用丰富安装即用",
          content:
            "即用流程-门户-文档-费控-合同-项目-采购-客服-人事等丰富场景应用，开箱即用",
        },
      ],
      module_item: [
        {
          img: require("../../../static/other/ic_module_item_img1.png"),
          title: "全渠道线索管理",
          content:
            "多渠道线索统一管理分析，聚合名片、官网注册、市场推广、销售自拓等多渠道线索，实现对线索的统一管理，助力企业不断优化获客渠道",
        },
        {
          img: require("../../../static/other/ic_module_item_img2.png"),
          title: "精细化客户管理",
          content:
            "客户信息全面记录，以精细化客户管理加速商机转化。客户标签精细分类，深度洞察客户需求，绘制客户精准画像",
        },
        {
          img: require("../../../static/other/ic_module_item_img3.png"),
          title: "智能化销售助手",
          content:
            "主动销售跟进客户、推进商机，提醒销售工作任务与待办事项，智能判别客户状态，智能分析业务数据、异常情况预警，出具改善建议",
        },
        {
          img: require("../../../static/other/ic_module_item_img4.png"),
          title: "可视化销售报表",
          content:
            "业绩进度可视化动态呈现，实时掌握业绩进度，目标分解、任务分发，保证销售业绩最终达成。全面洞察销售能力，销售日常工作行为报表化展现，员工管理有据可依",
        },
      ],
    };
  },
  methods: {},
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "500px";
      } else {
        return "250px";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height:100%; 
}
.introduce_bg {
  display: flex;
  flex-direction: column;
  background: #fff;
  height: 820px;
  align-items: center;
  .introduce_top {
    background: url("../../../static/other/bg_introduce_top.png");
    width: 1180px;
    height: 164px;
    margin-top: 58px;
    display: flex;
    flex-direction: column;

    .introduce_top_title {
      font-family: "PingFang SC";
      font-weight: 500;
      font-size: 28px;
      line-height: 39px;
      color: #333333;
      margin-bottom: 8px;
      margin-top: 24px;
      margin-left: 24px;
    }
    .introduce_top_content {
      width: 60%;
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #666666;
      margin-left: 24px;
      margin-bottom: 24px;
    }
  }
  .introduce_bottom {
    width: 1180px;
    display: flex;
    flex-direction: row;
    margin-top: 80px;

    .introduce_bottom_left_img {
      width: 438px;
      height: 438px;
      margin-top: 46px;
      margin-right: 90px;
    }
    .introduce_bottom_right {
      display: flex;
      flex-direction: column;

      .introduce_bottom_right_title {
        font-family: "PingFang SC";
        font-weight: 500;
        font-size: 28px;
        line-height: 39px;
        margin-top: 76px;
        margin-bottom: 8px;
        color: #333333;
      }
      .introduce_bottom_right_content {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        width: 650px;
        margin-bottom: 48px;
      }
      .introduce_bottom_right_img {
        width: 546px;
      }
    }
  }
}

.advantage_bg {
  width: 100%;
  height: 600px;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  align-items: center;

  .advantage_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 48px;
  }
  .flow_bg {
    width: 1180px;

    .advantage_border {
      height: 164px;
      border-radius: 10px;
      border: 1px solid #ebeef5;
      margin-bottom: 10px;
      margin-top: 10px;
      display: flex;
      background: #fff;
      flex-direction: row;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .line {
        width: 3px;
        height: 18px;
        margin-left: 24px;
        margin-right: 8px;
        margin-top: 32px;
      }
      .advantage_right {
        display: flex;
        flex-direction: column;
        margin-right: 24px;
        margin-top: 28px;

        .advantage_right_title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 18px;
          line-height: 25px;
          color: #333333;
          margin-bottom: 12px;
        }
        .advantage_right_content {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #666666;
        }
      }
    }
  }
}
.serve_bg {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;

  .serve_title {
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    line-height: 39px;
    text-align: center;
    color: #333333;
    margin-top: 80px;
    margin-bottom: 8px;
  }
  .serve_content {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #666666;
    margin-bottom: 80px;
  }
  .serve_bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 50px;

    .serve_bottom_left {
      width: 50%;
      display: flex;
      justify-content: flex-end;
      .serve_bottom_left_img {
        width: 490px;
        height: 470px;
        margin-top: 57px;
        margin-right: 110px;
      }
    }
    .serve_bottom_right {
      width: 50%;
      .serve_bottom_right_img {
        width: 580px;
      }
    }
  }
}

.module_parent {
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 80px;
  padding-bottom: 80px;

  .module_title {
    width: 400px;
    font-family: "PingFang SC";
    font-weight: 500;
    font-size: 28px;
    text-align: center;
    color: #333333;
    margin-bottom: 8px;
  }
  .module_info {
    font-family: "PingFang SC";
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #666666;
    margin-bottom: 48px;
  }

  .module_card {
    width: 1180px;
    margin: auto;

    .module_border {
      height: 200px;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid #ebeef5;
      margin-bottom: 10px;
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .module_left {
        display: flex;
        align-items: center;
        margin-left: 32px;
        margin-right: 32px;
        .module_img {
          width: 56px;
          height: 56px;
        }
      }
      .module_right {
        display: flex;
        margin-right: 48px;
        flex-direction: column;
        justify-content: flex-start;

        .title {
          font-family: "PingFang SC";
          font-weight: 500;
          font-size: 20px;
          color: #000000;
          margin-bottom: 8px;
          margin-top: 32px;
        }
        .content {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 16px;
          color: #666666;
        }
      }
    }
  }
}
</style>